<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.maritimeObject') }}
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object1" :objectHeader="objectHeader1"></BasicDatabaseObjects>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object5" :objectHeader="objectHeader5"></BasicDatabaseObjects>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object6" :objectHeader="objectHeader6"></BasicDatabaseObjects>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object7" :objectHeader="objectHeader7"></BasicDatabaseObjects>
            </v-col>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.entity') }}
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object9" :objectHeader="objectHeader9"></BasicDatabaseObjects>
            </v-col>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.invoices') }}
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" lg="3">
                <BasicDatabaseObjects :objectName="object10" :objectHeader="objectHeader10"></BasicDatabaseObjects>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BasicDatabaseObjects from './BasicDatabaseObjects';

export default {
    name: 'OtherDatabases',
    components: {BasicDatabaseObjects},
    data: function () {
        return {
            object1: 'vessel-types',
            objectHeader1: 'Vessel type',
            object2: 'vessel-sizes',
            objectHeader2: 'Vessel size',
            object3: 'pumping-systems',
            objectHeader3: 'Pumping system',
            object4: 'cargo-handling-gears',
            objectHeader4: 'Cargo handling gear',
            object5: 'engine-types',
            objectHeader5: 'Engine type',
            object6: 'dp-types',
            objectHeader6: 'DP type',
            object7: 'dp-manufacturers',
            objectHeader7: 'DP manufacturer',
            object8: 'port-of-registries',
            objectHeader8: 'Port of registry',
            object9: 'entity-types',
            objectHeader9: 'Entity type',
            object10: 'invoice-item-types',
            objectHeader10: 'Invoice item type',
        };
    },
    methods: {},
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.otherDatabases'), href: '/#/other-databases', disabled: true},
        ]);
    },
};
</script>

<style scoped></style>
